import {
    GET_DASHBOARD_ALL_KPIS_SUCCESS,
    GET_DASHBOARD_ASSIGNED_CLIENTS_SUCCESS,
    GET_DASHBOARD_CLIENTS_OVERVIEW_SUCCESS,
    GET_DASHBOARD_CREDENTIAL_ALERTS_SUCCESS,
    GET_DASHBOARD_EXPIRING_AUTHS_SUCCESS,
    GET_DASHBOARD_INSURANCE_ALERTS_SUCCESS,
    GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS_SUCCESS,
    GET_DASHBOARD_MY_TASKS_SUCCESS,
    GET_DASHBOARD_SESSION_NOTE_REQUESTS_SUCCESS,
    GET_DASHBOARD_UPCOMING_APPTS_SUCCESS,
    GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS,
    GET_DASHBOARD_USER_KPIS_SUCCESS,
    REORDER__DASHBOARD_KPIS,
} from './dashboard.types';

const initialState = {
    listKpis: [],
    allKpis: [],
    userKpis: [],
    upcomingAppointments: [],
    clientsOverview: null,
    credentialAlerts: null,
    assignedClients: null,
    myTasks: null,
    expiringAuthorizations: null,
    insuranceAlerts: null,
    clientDocumentAlerts: null,
    sessionNoteRequests: null,
};

export const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        /** Analytics */

        case GET_DASHBOARD_USER_FILTERED_KPIS_SUCCESS:
            return {
                ...state,
                listKpis: action?.payload,
            };

        case GET_DASHBOARD_ALL_KPIS_SUCCESS:
            return {
                ...state,
                allKpis: action?.payload,
            };

        case GET_DASHBOARD_USER_KPIS_SUCCESS:
            return {
                ...state,
                userKpis: action?.payload?.filter((u) => u?.id),
            };

        case GET_DASHBOARD_UPCOMING_APPTS_SUCCESS:
            return {
                ...state,
                upcomingAppointments: action?.payload,
            };

        case GET_DASHBOARD_CLIENTS_OVERVIEW_SUCCESS:
            return {
                ...state,
                clientsOverview: action?.payload,
            };

        case GET_DASHBOARD_CREDENTIAL_ALERTS_SUCCESS:
            return {
                ...state,
                credentialAlerts: action?.payload,
            };

        case GET_DASHBOARD_ASSIGNED_CLIENTS_SUCCESS:
            return {
                ...state,
                assignedClients: action?.payload,
            };

        case GET_DASHBOARD_MY_TASKS_SUCCESS:
            return {
                ...state,
                myTasks: action?.payload,
            };

        case GET_DASHBOARD_EXPIRING_AUTHS_SUCCESS:
            return {
                ...state,
                expiringAuthorizations: action?.payload,
            };

        case GET_DASHBOARD_INSURANCE_ALERTS_SUCCESS:
            return {
                ...state,
                insuranceAlerts: action?.payload,
            };

        case GET_DASHBOARD_CLIENT_DOCUMENT_ALERTS_SUCCESS:
            return {
                ...state,
                clientDocumentAlerts: action?.payload,
            };

        case GET_DASHBOARD_SESSION_NOTE_REQUESTS_SUCCESS:
            return {
                ...state,
                sessionNoteRequests: action?.payload,
            };

        case REORDER__DASHBOARD_KPIS:
            return {
                ...state,
                userKpis: action?.payload?.body,
            };

        /** End */

        default:
            return state;
    }
};
